import styled from 'styled-components';
import {InputRangeProps} from './types';

export const Wrapper = styled.div<
  Pick<InputRangeProps, 'color'>
>`
  .slider {
    width: 100%;
    height: 55px;
    border-radius: 5px;
    overflow: hidden;
  }
  
  .thumb {
    height: 55px;
    width: 0;
    
    &:after {
      content: "";

      margin-top: 12.5px;
      height: 30px;
      width: 4px;
      border-radius: 2px;
      display: inline-grid;
      margin-left: -2px;
      background: ${({theme}) => theme.colors.white};
    }
  }
  
  .track {
    height: 55px;
  }

  .track.track-0 {
    background: ${({color}) => color};
    border-radius: 5px;
  }
  
  .track.track-1 {
    background: ${({theme}) => `
      ${theme.variables.backgroundColor};
    `};
  }
`;
